import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { TableauViz, TableauEventType } from '@tableau/embedding-api';
import Subtitle from '../Shared/Subtitle';
import Grid from '@mui/material/Grid';
import JobRecordRow from '../Job/JobRecordRow';

import actions from '../Config/actions';

const JobRecords = props => {
    const schemas = useSelector(state => state.schemas);
    const queries = useSelector(state => state.queries);
    const sysconfig = useSelector(state => state.sysconfig);

    const [input, setInput] = useState(props.input)
    const [node, setNode] = useState(props.input.target.system === 'sqlserver' ? 'source' : 'target')
    const [options, setOptions] = useState({})
    const [tableauViz, setTableauViz] = useState()
    // const [attributes, setAttributes] = useState()

    useEffect(() => {
        const newNode = props.input.target.system === 'sqlserver' ? 'source' : 'target'
        setInput(props.input)
        setNode(newNode)
        setOptions({
            names: schemas.data ? makeOptionsNames(newNode) : [],
            params: schemas.data ? makeOptionsParams(newNode) : [],
            attributes: props.input ? makeOptionsAttributes(props.input) : [],
        })
    }, [props, schemas.data])

    const makeOptionsNames = node => {
        return schemas.data.filter(x =>
            x.SystemKey === props.input[node].system
        ).map(x => ({
            value: x.Name,
            label: x.Name
        }))
    }

    const makeOptionsParams = node => {
        let newOpts = {}
        const system = props.input[node].system
        const type = props.input[node].type
        const params = sysconfig?.data?.find(y => y.SystemKey == system)?.Actions?.find(y => y.type == type)?.params || []
        schemas.data.filter(x =>
            x.SystemKey === props.input[node].system
        ).forEach(x =>
            newOpts[x.Name] = [
                ...Object.keys(x.Fields),
                ...params
            ].sort().map(y => ({
                value: y,
                label: y
            }))
        )
        return newOpts
    }

    const makeOptionsAttributes = input => {
        let opts = attributes.filter(x => x.type === 'select').map(x => ({ [x.name]: x?.options })).reduce((a, b)=>({...a,...b}), {})
        opts['queryId'] = queries?.data?.map(x=>({value: x.Id, label: x.Name}))
        return opts
    }
    
    const attributes = input && [
        ...actions[input.source.action]?.attributes || [],
        ...actions[input.target.action]?.attributes || [],
        ...actions[input.source.system]?.[input.source.action]?.attributes || [],
        ...actions[input.target.system]?.[input.target.action]?.attributes || []
    ]

    const handleRecordChange = (e, key) => {
        // change records
        let newRecords = [...input?.records || []]
        if (e.target.name === "record_order") {
            newRecords.splice(key + e.target.value, 0, newRecords.splice(key, 1)[0])
        } else if (e.target.name === "add") {
            newRecords = [...(newRecords || []), ...[{ object: '' }]]
        } else if (e.target.name === "delete") {
            newRecords.splice(key, 1)
        } else if (e.target.name === "tableau") {
            newRecords[key] = {
                ...e.target.value 
            }
        } else {
            newRecords[key] = {
                ...newRecords[key],
                ...{ [e.target.name]: e.target.value }
            }
            !newRecords[key].params && delete newRecords[key].params
        }
        setInput({
            ...input,
            ...{ records: newRecords }
        })
        console.log(newRecords)
        props.handler({ target: { name: 'Input', input: 'records', value: newRecords } })
    }

    return (
        <Grid container className="Container">
            <Subtitle
                type="Record"
                new
                handler={() => handleRecordChange({ target: { name: "add" } })}
            />

            {/* Records */}
            {input?.records && input.records.map((item, key) => {
                return (
                    <JobRecordRow
                        key={key}
                        rowNumber={key}
                        item={item}
                        node={node}
                        attributes={attributes}
                        options={options}
                        tableauViz={tableauViz}
                        handler={e => handleRecordChange(e, key)}
                    />
                )
            })}
        </Grid>

    )
}
export default JobRecords;